import React, { useEffect, useState, useRef } from 'react';
import './MiniStats.css';

function MiniStats() {
  const [counts, setCounts] = useState({ companies: 0, countries: 0, assets: 0 });
  const [isVisible, setIsVisible] = useState(false);
  const statsRef = useRef(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting && !isVisible) {
          setIsVisible(true);
        }
      },
      { threshold: 0.3 }
    );

    const currentRef = statsRef.current;

    if (currentRef) {
      observer.observe(currentRef);
    }

    return () => {
      if (currentRef) {
        observer.unobserve(currentRef);
      }
    };
  }, [isVisible]);

  useEffect(() => {
    if (!isVisible) return;

    const duration = 2000;
    const steps = 60;
    const stepDuration = duration / steps;

    const targets = {
      companies: 10,
      countries: 9,
      assets: 390
    };

    let currentStep = 0;

    const timer = setInterval(() => {
      currentStep++;
      const progress = currentStep / steps;

      setCounts({
        companies: Math.round(targets.companies * progress),
        countries: Math.round(targets.countries * progress),
        assets: Math.round(targets.assets * progress)
      });

      if (currentStep >= steps) {
        clearInterval(timer);
        setCounts(targets);
      }
    }, stepDuration);

    return () => clearInterval(timer);
  }, [isVisible]);

  return (
    <section className="mini-stats" ref={statsRef}>
      <div className="container">
        <div className="mini-stats-grid">
          <div className="mini-stat-item">
            <div className="mini-stat-number">+{counts.companies}</div>
            <div className="mini-stat-label">Empresas</div>
          </div>

          <div className="mini-stat-item">
            <div className="mini-stat-number">+{counts.countries}</div>
            <div className="mini-stat-label">Países</div>
          </div>

          <div className="mini-stat-item">
            <div className="mini-stat-number">+{counts.assets}M€</div>
            <div className="mini-stat-label">Activos</div>
          </div>
        </div>
      </div>
    </section>
  );
}

export default MiniStats;
